'use client';

import AccountPageMenu from '@/components/AccountPageMenu';
import FormError from '@/components/FormError';
import { useUserContext } from '@/context/user';
import { SET_NEWSLETTER_SUBSCRIPTION } from '@/graphql/mutation/set-customer-subscription';
import { GET_CUSTOMER_SUBSCRIPTION } from '@/graphql/queries/get-customer-subscription';
import { trans } from '@/i18n';
import { useMutation, useQuery } from '@apollo/client';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const CommunicationsPage = () => {
  const router = useRouter();
  const [{ isSignedIn }] = useUserContext();
  const { register, handleSubmit, reset } = useForm({
    defaultValues: {
      isSubscribed: false,
    },
  });
  const { error: getCustomerSubscriptionError } = useQuery(GET_CUSTOMER_SUBSCRIPTION, {
    fetchPolicy: 'cache-and-network',
    skip: !isSignedIn,
    onCompleted: data => {
      reset({
        isSubscribed: !!data?.customer?.is_subscribed,
      });
    },
  });
  const [
    reqSetNewsletterSubscription,
    { loading: setNewsletterSubscriptionInProgress, data: setNewsletterRes, error: setCustomerSubscriptionError },
  ] = useMutation(SET_NEWSLETTER_SUBSCRIPTION);

  useEffect(() => {
    if (!isSignedIn) {
      router.replace('/sign-in');
    }
  }, [isSignedIn, router]);

  const handleSetNewsletterSubscription = values => {
    reqSetNewsletterSubscription({
      variables: values,
    });
  };

  return (
    <div className='mx-auto max-w-site  px-2.5 pb-[84px] pt-5 lg_flex lg_justify-between lg_px-0 lg_pb-[122px] lg_pt-[60px]'>
      <AccountPageMenu />
      <div className='shrink pt-[30px] lg_basis-[1100px] lg_pt-0'>
        <h1 className='text-center font-Shango text-[28px] leading-[23px]'>{trans('Newsletter Subscription')}</h1>
        <p
          className={clsx(
            ' text-lg font-medium leading-[22px] ',
            'py-2.5',
            'border-b-1 border-solid border-E7DED5',
            'mt-[38px] lg_mt-[68px]',
          )}
        >
          {trans('Subscription option')}
        </p>

        <form
          className='mt-5'
          onSubmit={handleSubmit(handleSetNewsletterSubscription)}
        >
          <label className='flex max-w-max cursor-pointer items-center gap-x-2.5'>
            <input
              type='checkbox'
              {...register('isSubscribed')}
              className={clsx(
                'cursor-pointer',
                ' h-[18px] w-[18px] appearance-none ',
                'rounded-none outline-0',
                'border-1 border-solid border-80583F',
                'relative',
                'checked_after_absolute checked_after_content-[""]',
                'checked_after_h-3 checked_after_w-3',
                'checked_after_bg-80583F',
                'checked_after_left-1/2 checked_after_top-1/2',
                'checked_after_-translate-x-1/2 checked_after_-translate-y-1/2',
              )}
            />
            <span className=' text-sm leading-5'>{trans('General Subscription')}</span>
          </label>
          <div className='mt-[30px] flex items-end gap-x-[30px]'>
            <button
              disabled={setNewsletterSubscriptionInProgress}
              type='submit'
              className={clsx(
                ' h-10 w-[120px] ',
                'rounded-[3px]',
                'text-sm font-medium leading-none',
                'flex items-center justify-center',
                'aw-default-btn',
              )}
            >
              {trans('SAVE')}
              {setNewsletterSubscriptionInProgress && '...'}
            </button>
            <Link
              className='text-sm leading-5 underline'
              href='/my-account'
            >
              {trans('Back')}
            </Link>
          </div>
        </form>
        {setNewsletterRes ? <div>{trans('Your preferences have been updated.')}</div> : null}
        <FormError errors={[getCustomerSubscriptionError, setCustomerSubscriptionError]} />
      </div>
    </div>
  );
};

export default CommunicationsPage;
